var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("digitizingController", [
    "$rootScope",
    "$scope",
    "$window",
    "$timeout",
    "digitizingService",
    "randomService",
    function ($rootscope, $scope, $window, $timeout, digitizingService, randomService) {
        $scope.windowWidth = $window.innerWidth;

        // Initialize testimonials array
        $scope.testimonials = [];

        angular.element($window).bind("resize", function () {
            $scope.windowWidth = $window.innerWidth;
        });

        // Add keyboard event listener for modal navigation
        angular.element(document).bind("keydown", function(event) {
            $scope.handleKeyPress(event);
        });

        $scope.getSampleImages = function () {
            // Initialize samples arrays to prevent undefined errors
            $scope.samplesMaster = [];
            $scope.samples = [];
            $scope.showModal = false;
            $scope.currentModalIndex = 0;
            $scope.modalSamples = [];
            $scope.isLoadingSamples = true;
            $scope.samplesError = false;

            // Fetch sample images from new API endpoint
            digitizingService.getSampleImages().then(function (response) {
                $scope.isLoadingSamples = false;
                if (response && response.data && response.data.data) {
                    // Map the API response to include full image URLs
                    $scope.samplesMaster = response.data.data.map(function(sample) {
                        return {
                            fileName: sample.fileName,
                            fileSize: sample.fileSize,
                            lastModified: sample.lastModified,
                            imageUrl: window.__env.cdSampleImagesUrl + sample.fileName
                        };
                    });

                    // Show only first 6 samples on the page
                    $scope.samples = $scope.samplesMaster.slice(0, 6);

                    // Update modal samples
                    $scope.modalSamples = $scope.samplesMaster;
                } else {
                    console.error('Invalid response structure:', response);
                    $scope.samplesError = true;
                }
            }).catch(function(error) {
                console.error('Error fetching sample images:', error);
                $scope.isLoadingSamples = false;
                $scope.samplesError = true;
                // Set default empty arrays if API fails
                $scope.samplesMaster = [];
                $scope.samples = [];
                $scope.modalSamples = [];
            });

            // Fetch testimonials from new API endpoint
            digitizingService.getTestimonials().then(function (response) {
                if (response && response.data) {

                    // Filter testimonials to ensure they have valid author, rating, and quote
                    var validTestimonials = response.data.filter(function(testimonial) {
                        var hasAuthor = testimonial.firstName && testimonial.firstName.trim() !== '' && 
                                      testimonial.lastName && testimonial.lastName.trim() !== '';
                        var hasRating = testimonial.rating && testimonial.rating > 0;
                        var hasQuote = (testimonial.message && testimonial.message.trim() !== '') || 
                                     (testimonial.title && testimonial.title.trim() !== '');
                        
                        return hasAuthor && hasRating && hasQuote;
                    });

                    // Sort testimonials by title length (longer titles first)
                    var sortedTestimonials = validTestimonials.sort(function(a, b) {
                        var titleLengthA = a.title ? a.title.length : 0;
                        var titleLengthB = b.title ? b.title.length : 0;
                        return titleLengthB - titleLengthA;
                    });
                    
                    // Create a copy of the array to prevent mutation by randomService
                    var testimonialsCopy = sortedTestimonials.slice();
                    
                    // Use randomService to pick 3 testimonials
                    var selectedTestimonials = randomService.getRandomItemsfromListArray(testimonialsCopy, 3);
                    
                    // Map API response to template-expected format
                    $scope.testimonials = selectedTestimonials.map(function(testimonial) {
                        var quote = testimonial.message || testimonial.title || '';
                        // Capitalize first letter of quote
                        if (quote && quote.length > 0) {
                            quote = quote.charAt(0).toUpperCase() + quote.slice(1);
                        }
                        
                        return {
                            name: (testimonial.firstName || '') + ' ' + (testimonial.lastName || ''),
                            quote: quote,
                            rating: testimonial.rating || 5
                        };
                    });
                }
            }).catch(function(error) {
                console.error('Error fetching testimonials:', error);
                $scope.testimonials = [];
            });
        };

        // Modal functions
        $scope.openModal = function() {
            $scope.showModal = true;
            $scope.currentModalIndex = 0;
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
            
            // Ensure thumbnail grid is properly initialized
            $timeout(function() {
                $scope.scrollThumbnailIntoView(0);
            });
        };

        $scope.closeModal = function() {
            $scope.showModal = false;
            // Restore body scroll
            document.body.style.overflow = 'auto';
        };

        $scope.nextImage = function() {
            if ($scope.modalSamples && $scope.modalSamples.length > 0 && 
                $scope.currentModalIndex < $scope.modalSamples.length - 1) {
                $scope.currentModalIndex++;
                
                // Scroll the active thumbnail into view
                $timeout(function() {
                    $scope.scrollThumbnailIntoView($scope.currentModalIndex);
                });
            }
        };

        $scope.prevImage = function() {
            if ($scope.modalSamples && $scope.modalSamples.length > 0 && 
                $scope.currentModalIndex > 0) {
                $scope.currentModalIndex--;
                
                // Scroll the active thumbnail into view
                $timeout(function() {
                    $scope.scrollThumbnailIntoView($scope.currentModalIndex);
                });
            }
        };

        $scope.goToImage = function(index) {
            if ($scope.modalSamples && $scope.modalSamples.length > 0 && 
                index >= 0 && index < $scope.modalSamples.length) {
                $scope.currentModalIndex = index;
                
                // Scroll the active thumbnail into view after a short delay
                $timeout(function() {
                    $scope.scrollThumbnailIntoView(index);
                });
            }
        };

        // Scroll thumbnail into view
        $scope.scrollThumbnailIntoView = function(index) {
            $timeout(function() {
                var thumbnailGrid = document.querySelector('.thumbnail-grid');
                var activeThumbnail = thumbnailGrid ? thumbnailGrid.querySelector('.thumbnail-item.active') : null;
                
                if (thumbnailGrid && activeThumbnail) {
                    var containerWidth = thumbnailGrid.offsetWidth;
                    var thumbnailWidth = activeThumbnail.offsetWidth;
                    var thumbnailLeft = activeThumbnail.offsetLeft;
                    var scrollLeft = thumbnailGrid.scrollLeft;
                    
                    // Calculate if thumbnail is visible
                    var isVisible = (thumbnailLeft >= scrollLeft) && 
                                   (thumbnailLeft + thumbnailWidth <= scrollLeft + containerWidth);
                    
                    if (!isVisible) {
                        // Scroll to make thumbnail visible
                        var targetScrollLeft = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
                        thumbnailGrid.scrollTo({
                            left: targetScrollLeft,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        };

        // Keyboard navigation for modal
        $scope.handleKeyPress = function(event) {
            if (!$scope.showModal) return;
            
            switch(event.keyCode) {
                case 37: // Left arrow
                    $scope.prevImage();
                    break;
                case 39: // Right arrow
                    $scope.nextImage();
                    break;
                case 27: // Escape
                    $scope.closeModal();
                    break;
            }
        };

        $scope.getSampleImages();
    },
]);
